<a :class="['side-menu-link', { active: isActive }]" @click="navigate">
    <AppIcon v-if="item.icon" :icon="item.icon" :mdi="item.mdiIcon" left />
    {{ item.title }}
</a>